import React, { Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Form, Field } from "redux-form";
import { Link } from 'react-router';

import LogoWithoutLabel from '../../../assets/images/logo-without-label.png';
import Message from '../../../common/components/message/message';
import Loading from "../../../common/components/ui/loading/loading";
import Button from "../../../common/components/ui/button/button";

import types from '../authTypes';
import { forgotPassword } from '../authActions';
import { setLoading } from "../../../helpers/redux";
import { InputLabel } from '../../../common/components/form/fields';
import { FORM_RULES } from '../../../helpers/validations';

class ForgotPassword extends Component {

    onSubmit = (values) => {
        values["email"] = values["email"].trim().toLowerCase();
        this.props.setLoading(types.AUTH_LOADING, true);
        this.props.forgotPassword(values, this.props.router);
    }

	render() {
        const { handleSubmit } = this.props;
		return (
            <section className="forgotPassword">
                <div className="forgotPassword__box padding-bottom-medium">
                    <div className="forgotPassword__header-box">
                        <div className="margin-top-small ">
                            <p className="forgotPassword__header-box--title ">Recuperar senha</p>
                        </div>   
                        <div className="margin-top-small ">
                            <img src={LogoWithoutLabel} className="forgotPassword__header-box--img" alt="Logo"/>
                        </div>
                    </div>
                    <div className="forgotPassword__body">
                        <p>Para recuperar a sua senha informe corretamente o endereço de e-mail cadastrado e clique em "Enviar".</p>
                    </div>
                    <Form className="form forgotPassword__form-box" role='form' onSubmit={handleSubmit(this.onSubmit)} noValidate>
                        <div className="form__body">
                            <Field
                                inputClass="input--default"
                                component={InputLabel}
                                iconStyle={{fontSize: 20, paddingBottom: 11, paddingTop: 11}}
                                style={{textAlign: 'left', fontSize: '1.6rem', paddingBottom: 0}}
                                inputStyle={{ fontSize: '1.6rem', padding: 20, borderRadius: '1rem'}}
                                type="text"
                                name="email"
                                icon="icon-email"
                                autocomplete="username"
                                placeholder="Email"
                                cols='12 12 12 12'
                                validate={[FORM_RULES.required, FORM_RULES.email]}
                                />
                        </div>
                        <div>
                            <Button
                                text='Enviar'
                                type="submit"
                                style={{width: '92%', padding: 5}}
                                rounded
                                radius={10}
                                buttonType='primary'
                            />                            
                        </div>
                    </Form>
                    <div className="forgotPassword__footer-box margin-top-small">
                        <Link to='/' style={{flex: 1, textAlign: 'center'}}>Voltar a página principal</Link>
                    </div>
                </div>
                
                <Message />
                <Loading
                    isVisible={this.props.loading}
                />
            </section>
        )
	}
}

ForgotPassword = reduxForm({ form: 'registerForm' })(ForgotPassword);

const mapStateToProps = (state) => {
    return {
        user: state.auth.user,
        validToken: state.auth.validToken,
        loading: state.auth.loading
    }
}

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({forgotPassword, setLoading}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);